import React, { useState } from 'react';
import SideActionBoard from '../../../../../components/SideActionBoard';

import Webinar from './Webinar';

const Sidebar = ({ openSideActionBoard, setOpenSideActionBoard }) => {
  console.log('webinars openSideActionBoard', openSideActionBoard);
  const { action, ids } = openSideActionBoard;

  return (
    <SideActionBoard setOpenSideActionBoard={setOpenSideActionBoard}>
      <Webinar
        id={ids[0]}
        type={action}
        openSideActionBoard={openSideActionBoard}
        setOpenSideActionBoard={setOpenSideActionBoard}
      />
    </SideActionBoard>
  );
};

export default Sidebar;
